import PropTypes from 'prop-types';
import React from 'react';
import PlayTabList from './components/PlayTabList';
import { Navbar, PlayTabListItemLink } from './PlayNavigation.styles';
import Link from 'next/link';
import { useRouter } from 'next/router';

const PlayNavigation = ({ tabs, selectedTab, className, onClick }) => {
    const router = useRouter();

    return (
        <Navbar aria-label="Filtrera tablån" className={className}>
            <PlayTabList regTestItem="tab-list-item">
                {tabs.map((tab) => {
                    if (tab) {
                        const handleClick = onClick ? () => onClick(tab) : undefined;
                        let isSelected = selectedTab === tab.slug;
                        const queryValue = tab.queryValue ? tab.queryValue : 'tab';

                        const query = router.query || {};

                        return (
                            <Link
                                key={`${tab.slug}${tab.name}-tab`}
                                href={{
                                    pathname: router.pathname,
                                    query: {
                                        ...query,
                                        [queryValue]: tab.slug,
                                    },
                                }}
                                scroll={false}
                                passHref
                            >
                                <PlayTabListItemLink
                                    isSelected={isSelected}
                                    tabIndex="0"
                                    onClick={handleClick}
                                >
                                    {tab.name}
                                </PlayTabListItemLink>
                            </Link>
                        );
                    }
                })}
            </PlayTabList>
        </Navbar>
    );
};

PlayNavigation.propTypes = {
    tabs: PropTypes.array.isRequired,
    selectedTab: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default PlayNavigation;
